// Navigation loader for the shop / product-listing pages.
//
// Previously this rendered an animated GIF. GIFs decode on the main thread, so
// while the destination page's heavy work blocks that thread the GIF stalls and
// the loader looks frozen ("jerky"). This is now a content-shaped skeleton whose
// only animation is `animate-pulse` (an opacity keyframe). Opacity animates on the
// compositor thread, so it keeps pulsing smoothly even while the main thread is
// busy — and a skeleton reads as "content loading" instead of a blank screen.
const Block = ({
  className = ''
}: {
  className?: string;
}) => <div className={`bg-gray-200 rounded-md ${className}`} data-sentry-component="Block" data-sentry-source-file="NavigationLoader.tsx" />;
const CardSkeleton = () => <div className="flex flex-col gap-2 p-3 border border-gray-100 rounded-lg" data-sentry-component="CardSkeleton" data-sentry-source-file="NavigationLoader.tsx">
    <Block className="h-24 w-full" data-sentry-element="Block" data-sentry-source-file="NavigationLoader.tsx" />
    <Block className="h-3 w-11/12" data-sentry-element="Block" data-sentry-source-file="NavigationLoader.tsx" />
    <Block className="h-3 w-2/3" data-sentry-element="Block" data-sentry-source-file="NavigationLoader.tsx" />
    <Block className="h-4 w-1/3 mt-1" data-sentry-element="Block" data-sentry-source-file="NavigationLoader.tsx" />
    <Block className="h-9 w-full mt-1" data-sentry-element="Block" data-sentry-source-file="NavigationLoader.tsx" />
  </div>;
const NavigationLoader = () => {
  return <div className="top-0 left-0 fixed bg-white z-[100] w-screen h-screen overflow-hidden" data-testid="spinner-div" aria-busy="true" aria-label="Loading products" data-sentry-component="NavigationLoader" data-sentry-source-file="NavigationLoader.tsx">
      <div className="animate-pulse flex flex-col gap-5 px-4 pt-6 max-w-7xl mx-auto">
        {/* search bar */}
        <Block className="h-11 w-full" data-sentry-element="Block" data-sentry-source-file="NavigationLoader.tsx" />
        {/* category tiles */}
        <div className="flex gap-3 overflow-hidden">
          {Array.from({
          length: 4
        }).map((_, i) => <Block key={i} className="h-24 w-24 shrink-0" />)}
        </div>
        {/* product grid */}
        <div className="grid grid-cols-2 gap-3">
          {Array.from({
          length: 4
        }).map((_, i) => <CardSkeleton key={i} />)}
        </div>
      </div>
    </div>;
};
export default NavigationLoader;